import { getAllRole } from "App/Component/layout/Access/Role/helpers";
import { DEFAULT_VALUE_OPTION } from "App/constants";
import { useState, useEffect } from "react";

const useInitialRole = (withSearch = false) => {
  const DEFAULT_OPTION = withSearch ? [] : DEFAULT_VALUE_OPTION("Role");

  const [state, setState] = useState(DEFAULT_OPTION);
  useEffect(() => {
    (async () => {
      const res = await getAllRole();
      if (res) {
        const data = withSearch
          ? []
          : [
              {
                value: 0,
                label: "Pilih Role",
              },
            ];
        res.map((item) => {
          return data.push({
            value: item.id,
            label: item.nama_role,
          });
        });

        setState(data);
      }
    })();
  }, [withSearch]);

  return state;
};

export default useInitialRole;
